import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    GetOption,
    HateoasResourceOperation,
    PagedGetOption,
} from '@lagoshny/ngx-hateoas-client';
import { Environment, ENVIRONMENT, FrontdoorProcessExecution } from '@netfoundry-ui/shared/model';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FeatureService} from './feature.service';
import { HTTP_CLIENT } from './token.service';

@Injectable({ providedIn: 'root' })
export class ProcessExecutionFrontdoorService extends HateoasResourceOperation<FrontdoorProcessExecution> {
    static defaultPaginationSize = 500;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };
    apiUrl: string;
    lastPageCount = 0;
    lastTotalCount = 0;

    constructor(
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment,
        private featureService: FeatureService,
    ) {
        super(FrontdoorProcessExecution);
        this.apiUrl = environment.frontdoorURL;
    }

    getResource(): Observable<FrontdoorProcessExecution> {
        throw new Error('Do not use: see get getProcessExecution');
    }

    getProcessExecution(id, options: GetOption = {}): Promise<FrontdoorProcessExecution> {
        return super
            .getResource(id, { ...ProcessExecutionFrontdoorService.defaultHttpAccept, ...options })
            .toPromise()
            .then((rec) => rec);
    }
    public getExecutionData(frontdoorId, executionId: number, isV2: boolean,): Promise<any> {
        const headers = new HttpHeaders().set('Accept', 'application/hal+json');
        const version = isV2 ? '/v2' : '';
        const params = new HttpParams();
        return this.http
            .get(this.apiUrl + `${version}/${frontdoorId}/` + `executions/${executionId}?meta=processData`, {
                headers: headers,
                params: params,
            })
            .toPromise();
    }

    //    async getProcessExecutionPage(frontdoorId?: string, options?: PagedGetOption): Promise<FrontdoorProcessExecution[]> {
    //     const headers = new HttpHeaders().set('Accept', 'application/hal+json');
    //     let params :PagedGetOption = {...ProcessExecutionFrontdoorService.defaultHttpAccept, ...options}
    //     return this.http
    //         .get(this.apiUrl + `/${frontdoorId}/executions?sort=createdAt,DESC`, {
    //             headers: headers,
    //             params: params,
    //         })
    //         .pipe(
    //           tap((val) => {
    //                 this.lastPageCount = val.totalPages;
    //                 this.lastTotalCount = val.totalElements;
    //           })
    //         )
    //         .toPromise()
    //         .then((processes: any) => processes._embedded.executionList);
    // }

    async getProcessExecutionPage(
  frontdoorId?: string,
  isV2?: boolean,
  options?: PagedGetOption
): Promise<FrontdoorProcessExecution[]> {
  const headers = new HttpHeaders().set('Accept', 'application/hal+json');
  const version = isV2 ? '/v2' : '';

  let params = new HttpParams().set('sort', 'createdAt,DESC');

if(options) {
    if (options.pageParams) {
      Object.keys(options.pageParams).forEach(key => {
        const value = options.pageParams[key]; // <-- Corrected
        if (value !== undefined && value !== null) {
          params = params.append(key, String(value));
        }
      });
    }

   // Handle the nested params object
    if (options.params) {
      Object.keys(options.params).forEach(key => {
        const value = options.params[key]; // <-- Corrected
        if (value !== undefined && value !== null) {
          params = params.append(key, String(value));
        }
      });
    
  }
}


  return this.http
    .get<any>(`${this.apiUrl}${version}/${frontdoorId}/executions`, {
      headers,
      params,
    })
    .pipe(
      tap((val) => {
        this.lastPageCount = val.page.totalPages;
        this.lastTotalCount = val.page.totalElements;
      })
    )
    .toPromise()
    .then((processes) => processes._embedded.executionList as FrontdoorProcessExecution[]);
}



    doExecutionAction(action) {
      const url = action.url;
      const headers = new HttpHeaders().set('Accept', 'application/hal+json');
      const params = new HttpParams();
      if (action.method === 'PUT') {
        return this.http.put(url, {headers: headers,params: params}).toPromise();
      } else if (action.method === 'POST') {
        return this.http.post(url, {headers: headers,params: params}).toPromise();
      } else if (action.method === 'GET') {
        return this.http.get(url, {headers: headers,params: params}).toPromise();
      } else if (action.method === 'DELETE') {
        return this.http.delete(url, {headers: headers,params: params}).toPromise();
      } else if (action.method === 'PATCH') {
        return this.http.patch(url, {headers: headers,params: params}).toPromise();
      }
    }

    retryExecution(executionId) {
      const headers = new HttpHeaders().set('Accept', 'application/hal+json');
      const params = new HttpParams();
      return this.http
        .post(this.apiUrl + `executions/${executionId}/retry`, {
          headers: headers,
          params: params,
        })
        .toPromise();
    }

    // WARNING: getProcessExecutionsByNetworkId() is an expensive operation - use at your own risk
    // in fact, don't use it
    async getProcessExecutionsByNetworkId(
        networkId: string,
        options = {},
        includeProps = ''
    ): Promise<FrontdoorProcessExecution[]> {
        throw new Error('Do not use: too expensive');
    }
}
